import { NotifDefTypes } from "@/generated/classes/NotifDef";

export function notifClass(notifDefType: NotifDefTypes) : string {
  let res = ''
  if (notifDefType == NotifDefTypes.ACTION) {
    res = 'notif-action';
  } else if (notifDefType == NotifDefTypes.INFO) {
    res = 'notif-info';
  }
  return res;
}